module.exports = __webpack_public_path__ + "assets/media/m-4.ebb4a45e.svg";